import UserDetailsHeader from './UserDetailsHeader';

export default UserDetailsHeader;
